(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["smilab-cart-subscription"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('smilab-cart-upgrade')) {
  customElements.define('smilab-cart-upgrade', class extends HTMLElement {
    connectedCallback() {
      if(this.initialized) return;
      this.initialized = true;
      this.addEventListener('change', e => { e.stopPropagation(); const option=this.querySelector('select').selectedOptions[0]; this.querySelector('[data-price-summary]').textContent=option.dataset.summary; });
      this.querySelector('button').addEventListener('click', () => this.upgrade());
    }
    async upgrade() {
      if(window.smilabCartUpgradeBusy) return;
      window.smilabCartUpgradeBusy = true;
      const button=this.querySelector('button'), select=this.querySelector('select'), status=this.querySelector('[role=status]');
      const plan=Number(select.value);
      if(!plan){window.smilabCartUpgradeBusy=false;return;}
      const lock=Array.from(document.querySelectorAll('smilab-cart-upgrade button,smilab-cart-upgrade select,button[name="checkout"],input[name="updates[]"]'));
      const disabled=lock.map(el=>el.disabled);
      lock.forEach(el=>el.disabled=true);
      button.setAttribute('aria-busy','true');
      status.hidden=true;
      const base=window.Shopify?.routes?.root || '/';
      let changed=false;
      try {
        const cartResponse=await fetch(base+'cart.js',{headers:{Accept:'application/json'}});
        if(!cartResponse.ok) throw new Error(this.dataset.error);
        const cart=await cartResponse.json();
        const lineIndex=cart.items.findIndex(item=>item.key===this.dataset.key && String(item.variant_id)===this.dataset.variant && !item.selling_plan_allocation);
        if(lineIndex<0) throw new Error(this.dataset.error);
        if(typeof window.__markInternalCartCall==='function') window.__markInternalCartCall();
        const replacements=[['cart-drawer','#CartDrawer'],['cart-icon-bubble','#cart-icon-bubble'],['main-cart-items','#main-cart-items'],['main-cart-footer','#main-cart-footer']].map(([section,selector])=>[document.querySelector(selector)?.dataset.id || section,selector]);
        const response=await fetch(base+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line:lineIndex+1,quantity:cart.items[lineIndex].quantity,selling_plan:plan,sections:replacements.map(([section])=>section),sections_url:location.pathname})});
        const result=await response.json();
        if(!response.ok || result.errors || result.status) throw new Error(typeof result.description==='string' ? result.description : this.dataset.error);
        changed=true;
        status.textContent=this.dataset.success;status.hidden=false;
        let refreshed=false;
        for(const [section,selector] of replacements){
          const html=result.sections?.[section];
          const target=document.querySelector(selector);
          if(!target) continue;
          if(!html) { location.reload(); return; }
          const source=new DOMParser().parseFromString(html,'text/html').querySelector(selector);
          if(source){target.innerHTML=source.innerHTML;refreshed=true;} else { location.reload(); return; }
        }
        if(!refreshed) location.reload();
        if(typeof publish==='function' && typeof PUB_SUB_EVENTS!=='undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'cart-items',cartData:result});
      } catch(error) {
        if(changed) location.reload();
        else {status.textContent=error.message || this.dataset.error;status.hidden=false;}
      } finally {
        lock.forEach((el,i)=>el.disabled=disabled[i]);
        button.removeAttribute('aria-busy');
        window.smilabCartUpgradeBusy=false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["smilab-cart-timer"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('smilab-cart-timer')){
customElements.define('smilab-cart-timer',class extends HTMLElement{
connectedCallback(){
this.key='smilab-cart-ten-minute-deadline';
if(this.dataset.empty==='true'){try{sessionStorage.removeItem(this.key)}catch(e){}window.smilabCartTimerDeadline=null;return}
const drawer=this.closest('cart-drawer');
if(drawer){this.observer=new MutationObserver(()=>{if(drawer.classList.contains('active'))this.start()});this.observer.observe(drawer,{attributes:true,attributeFilter:['class']});if(drawer.classList.contains('active'))this.start()}else this.start();
}
start(){
if(this.interval)return;
let stored;try{stored=Number(sessionStorage.getItem(this.key))}catch(e){}
this.deadline=stored||window.smilabCartTimerDeadline||Date.now()+600000;
window.smilabCartTimerDeadline=this.deadline;
try{sessionStorage.setItem(this.key,String(this.deadline))}catch(e){}
const render=()=>{const seconds=Math.max(0,Math.ceil((this.deadline-Date.now())/1000));this.hidden=seconds===0;this.querySelector('strong').textContent=String(Math.floor(seconds/60)).padStart(2,'0')+':'+String(seconds%60).padStart(2,'0');};
render();this.interval=setInterval(render,1000);
}
disconnectedCallback(){clearInterval(this.interval);this.interval=null;this.observer?.disconnect()}
});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["smilab-purchase-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('smilab-purchase-options')) {
  customElements.define('smilab-purchase-options', class extends HTMLElement {
    connectedCallback() {
      if(this.initialized) return;
      this.initialized = true;
      this.variants = JSON.parse(this.querySelector('[data-sm-variants]').textContent);
      this.form = this.closest('form');
      this.root = this.closest('[data-sp-buy]');
      this.frequency = this.querySelector('[data-sm-frequency]');
      this.addEventListener('change', () => this.update());
      this.update();
    }
    getPurchaseData() {
      const color = this.querySelector('[name^="sm-color-"]:checked');
      const variant = this.variants.find(v => String(v.id) === (color?.value || this.form.elements.id.value));
      if(!variant?.available) throw new Error(this.dataset.unavailable);
      const data = new FormData(this.form);
      data.set('id', variant.id);
      // Seal can inject its own hidden field. Only our visible selection determines the order.
      data.delete('selling_plan');
      if(this.querySelector('[value="subscription"]').checked) {
        const plan = variant.plans.find(p => String(p.id) === this.frequency.value);
        if(!plan) throw new Error(this.dataset.unavailable);
        data.set('selling_plan', plan.id);
      }
      return data;
    }
    update() {
      const color = this.querySelector('[name^="sm-color-"]:checked');
      const variant = this.variants.find(v => String(v.id) === (color?.value || this.form.elements.id.value));
      if(!variant) return;
      this.form.elements.id.value = variant.id;
      const previous = this.frequency.value;
      this.frequency.replaceChildren(...variant.plans.map(p => new Option(p.label, p.id)));
      if(variant.plans.some(p => String(p.id) === previous)) this.frequency.value = previous;
      const subscriptionRadio = this.querySelector('[value="subscription"]');
      subscriptionRadio.disabled = !variant.plans.length;
      if(!variant.plans.length) this.querySelector('[value="once"]').checked = true;
      this.querySelectorAll('[data-sm-sub-content]').forEach(el => el.hidden = !variant.plans.length);
      const subscription = subscriptionRadio.checked;
      const plan = variant.plans.find(p => String(p.id) === this.frequency.value);
      this.querySelector('.sm-options__frequency').hidden = !subscription;
      this.frequency.disabled = !subscription;
      this.querySelector('[data-sm-once-price]').textContent = variant.price;
      this.querySelector('[data-sm-sub-price]').textContent = plan?.price || '';
      // Card display only: the reference is the current one-time price, not compare_at_price.
      // Order/cart construction and selling-plan identifiers below remain unchanged.
      if (this.dataset.smCardDesign === 'pastel') {
        const currency = this.dataset.smCurrency || 'EUR';
        const amount = cents => new Intl.NumberFormat('fr-FR', {style:'currency',currency}).format(cents / 100);
        const saving = Math.max(0, Number(variant.priceCents) - Number(plan?.priceCents ?? variant.priceCents));
        this.querySelector('[data-sm-once-price]').textContent = amount(variant.priceCents);
        this.querySelector('[data-sm-sub-price]').textContent = plan ? amount(plan.priceCents) : '';
        this.querySelector('[data-sm-compare-price]').textContent = amount(variant.priceCents);
        this.querySelector('[data-sm-reference]').hidden = !plan || saving <= 0;
        this.querySelector('[data-sm-saving-badge]').hidden = !plan || saving <= 0;
        this.querySelector('[data-sm-saving]').textContent = new Intl.NumberFormat('fr-FR', {
          style:'currency', currency, minimumFractionDigits:0, maximumFractionDigits:2
        }).format(saving / 100);
      }

      this.root.querySelectorAll('[data-sm-selected-price]').forEach(el => el.textContent = subscription && plan ? plan.price : variant.price);
      this.root.querySelectorAll('[data-sp-main], .sp-sticky button').forEach(b => {
        b.disabled = !variant.available;
        const label = b.querySelector('[data-sm-button-label]');
        if(label) label.textContent = variant.available ? label.dataset.available : this.dataset.unavailable;
      });
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
